// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getCart as customGetCart } from "@guestsupply/App/Services/CartService";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    GetCart,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const XngPopulateApiParameter: any = (props: any) => {
    const pageType = getCurrentPage(props.getState()).type;
    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        expand: ["cartLines"],
    };

    if (!getSession(props.getState()).rememberMe) {
        props.apiParameter.expand?.push("validation");
    }

    if (props.needFullCart) {
        props.apiParameter.forceRecalculation = true;
        props.apiParameter.allowInvalidAddress = true;
        props.apiParameter.expand = [
            ...(props.apiParameter.expand || []),
            "shipping",
            "restrictions",
            "tax",
            "carriers",
            "paymentOptions",
            "costCodes",
        ];

        if (pageType === "CartPage") {
            props.apiParameter.expand.push("hiddenproducts");
        }
    }

    if (props.parameter.getCostCodes) {
        props.apiParameter.expand?.push("costCodes");
    }
};

// XNG-CHANGES : Update getCart to read from guestsupply service for CheckoutReviewAndSubmitPage
export const XngGetCart: any = async (props: any) => {
    props.apiResult = await customGetCart(props.apiParameter);
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, GetCart, XngGetCart);
